
import React from 'react';

export const IndustryMarquee: React.FC = () => {
  const items = [
    "KARDIOLOGIE", "MASCHINENBAU", "LOGISTIK", "RADIOLOGIE", 
    "FINANCE", "REAL ESTATE", "E-COMMERCE", "GASTRONOMIE", 
    "STEUERBERATUNG", "PRODUKTION", "TOURISMUS", "HANDWERK", "JURISTIK", "VERSICHERUNG"
  ];

  // Tripling content for seamless loop
  const marqueeContent = [...items, ...items, ...items];

  return (
    <div className="w-full py-12 overflow-hidden relative bg-white border-b border-gray-100">
      <div className="absolute left-0 top-0 bottom-0 w-40 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-40 bg-gradient-to-l from-white to-transparent z-10" />
      
      <div className="flex whitespace-nowrap animate-marquee hover:[animation-play-state:paused] opacity-40 hover:opacity-100 transition-opacity duration-500">
        {marqueeContent.map((item, index) => (
          <div key={index} className="mx-12 flex items-center gap-4 select-none">
             <div className="w-1 h-1 bg-clever-teal rounded-full"></div>
             <span className="text-xs font-bold tracking-[0.2em] text-gray-900 uppercase font-mono">
               {item}
             </span>
          </div>
        ))}
      </div>
    </div>
  );
};
